import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';
import { getSocketStore } from './../../../libs/utils';
import { toJS } from '../../helpers/ImmutableToJS';
import * as c from './../../../libs/constants';

import { Header } from './header';
import { Body } from './body';
import { Ban } from './ban';
import { Unban } from './unban';

import { Spinner } from '../../ui/spinner';
import { Layout } from '../../ui/layout';

// styles
import css from './client.sss';

const ClientView = (props) => {
    const { isLoadingData, activeClientTab, closeDialog, modifiedClientRoom } = props;

    return (
        <Layout key='containerBesida' dataQa='besida_panel_block'>
            <Layout.Header>
                <Header closeDialog={closeDialog} />
            </Layout.Header>
            <Layout.Body>
                {isLoadingData.clientInfo ? (
                    <Spinner />
                ) : (
                    <div className={css.root}>
                        <Body />
                        {activeClientTab === c.CHAT_CLIENT_BAN && (
                            <Ban />
                        )}
                        {modifiedClientRoom.clientBanned && (
                            <Unban />
                        )}
                    </div>
                )}
            </Layout.Body>
        </Layout>
    );
};

ClientView.propTypes = {
    isLoadingData: PropTypes.object,
    activeClientTab: PropTypes.string,
    closeDialog: PropTypes.func,
};

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const modifiedClientRoom = getRoom(socketStore, state.get('prevOpenedRoomIdent'));

    return {
        isLoadingData: state.get('isLoadingData'),
        activeClientTab: state.get('activeClientTab'),
        locale: state.get('locale'),
        modifiedClientRoom,
    };
};

export const Client = connect(mapStateToProps)(toJS(ClientView));

